<section id="demon-170-tile">
    <div class="img-container">
        <img src="/assets/images/demon-170/gallery/MY23-Dodge-Challenger-SRT-Demon-170_11.webp" alt="2023 Challenger SRT Demon 170 - Gallery Image 11">
    </div>
    <a routerLink="/srt-demon-170" class="btn btn-primary">
        <span>1,025 HP. Zero BS.</span>
        <span>2023 Dodge Challenger SRT<sup>&reg;</sup> Demon 170</span>
    </a>
</section>
